import restaurantInterior from "@/assets/storia.webp";

const ChiSiamoSection = () => {
  return <section id="chi-siamo" className="section-padding bg-gradient-subtle">
      <div className="container-custom">
        {/* Centered Title */}
        <div className="text-center mb-12">
          <h2 className="text-section-title text-primary mb-4">
            Ristorante sul <span className="text-gold">Lago Trasimeno</span>
          </h2>
          <p className="text-body-large text-muted-foreground max-w-3xl mx-auto font-serif">
            Storia e tradizione della cucina umbra nel cuore di Passignano
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Text Content */}
          <article>
            
            <div className="space-y-6 text-body-large text-muted-foreground font-serif">
              <p>
                Il <strong>ristorante Da Armando</strong> accoglie da oltre 10 anni ospiti locali e internazionali nel cuore di <strong>Passignano sul Trasimeno</strong>, offrendo un'autentica esperienza di <strong>cucina umbra</strong> con vista panoramica sul lago.
              </p>
              
              <p>
                Situati sulla nostra <strong>terrazza panoramica di 200m²</strong>, vi faremo assaporare le specialità della tradizione umbra, dal <strong>pesce di lago freschissimo</strong> alle carni alla griglia, dai primi piatti fatti in casa ai dolci artigianali.
              </p>
              
              <p>
                La nostra filosofia è semplice: proporre un <strong>menù variegato e completo</strong> che celebri i sapori autentici dell'Umbria, utilizzando esclusivamente <strong>ingredienti locali di qualità</strong> e ricette tradizionali tramandate nel tempo.
              </p>
            </div>

            {/* Highlights */}
            <div className="grid grid-cols-2 gap-6 mt-12">
              <div className="text-center">
                <div className="text-3xl font-bold text-gold mb-2">200M²</div>
                <div className="text-sm text-muted-foreground">Terrazza Panoramica</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-gold mb-2">100%</div>
                <div className="text-sm text-muted-foreground">Ingredienti di Qualità</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-gold mb-2">10+</div>
                <div className="text-sm text-muted-foreground">Anni di Esperienza</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-gold mb-2 flex justify-center items-center">
                  <span className="text-2xl">★</span>
                  <span className="text-2xl">★</span>
                  <span className="text-2xl">★</span>
                  <span className="text-2xl">★</span>
                  <span className="text-2xl">★</span>
                </div>
                <div className="text-sm text-muted-foreground">Recensioni ospiti</div>
              </div>
            </div>
          </article>

          {/* Image */}
          <div className="image-hover">
            <img src={restaurantInterior} alt="Interno del ristorante Da Armando a Passignano sul Trasimeno - Terrazza panoramica con vista sul Lago Trasimeno, atmosfera elegante e accogliente per degustare cucina umbra autentica" loading="lazy" className="w-full h-[600px] object-cover rounded-2xl shadow-elegant" />
          </div>
        </div>
      </div>
    </section>;
};
export default ChiSiamoSection;